export enum DateActions {
  ChangeDateRangeRendered = 'Changing data range for booking calendar as rendered view',

  ScrollableDateRangeChanging = 'Changing date range for calendar scrollable (for whatever reason)',
  ScrollableDateRangeChanged = 'Changed date range for calendar scrollable',

  ChangeManualDate = 'Change booking calendar manual date',
  ChangedManualDate = 'Changed booking calendar manual date',
}

export enum RoomActions {
  RequestDataForRooms = 'Request data for rooms',
  DatabaseForRoomsIsEmpty = 'Database for rooms is empty, taking data from API',
  DataForRoomsAccepted = 'Data for rooms is accepted',
  DataForRoomsRejected = 'Data for rooms is rejected',

  RequestCreateRoom = 'Request for creating a new room',
  RoomWasCreated = 'Room was created successfully',

  RequestUpdateRoom = 'Request for updating an existing room',
  RoomWasUpdated = 'Room was updated successfully',

  RequestDeleteRoom = 'Request for remove room',
  RoomWasDeleted = 'Room was deleted successfully',

  RequestNext = 'Request next room',
  RequestPrev = 'Request previous room',

  SortRooms = 'Request sort rooms',
  RoomsWasSorted = 'Rooms sorted succesfully',
  RoomsSortRejected = 'Rooms sort was rejected',
}

export enum EventActions {
  RequestDataForEvents = 'Request data for events',
  DatabaseForEventsIsEmpty = 'Database for events is empty, taking data from API',
  DataForEventsAccepted = 'Data for events is accepted',
  DataForEventsRejected = 'Data for events is rejeceted',
  ShowEventHint = 'Show event hint with props',
  CloseEventHint = 'Close event hint',
  ToggleExpanderHint = 'Toggle expander hint',

  RequestDeleteEvent = 'Request for remove event',
  EventWasDeleted = 'Event was deleted successfully',

  RequestTransferReservation = 'Request for transfer reservation',
  ReservationWasTransfered = 'Reservation was transfered successfully',
  RequestCreateEvent = 'request for event creations',
  EventWasCreated = 'Event was created successfully',
  ReservationWasCopied = 'Event was copied successfully',
  RequestCopyReservation = 'Request reservation copy',
  EventWasUpdated = 'Event was successfully updated',
  RequestUpdateEvent = 'Request update event',
  EventsBulkCreated = 'Request create bulk events',
  RequestEventsForCalendar = 'Request events for calendar',
  ToggleFallbackLoading = 'Toggle event fallback loading',
}

export enum CalendarActions {
  SetOnbordingShow = 'Set onboarding calendar modal show',
  OpenOnbordingModal = 'Open onboarding calendar modal',
  ToggleOnbordingModal = 'Set onboarding calendar modal hide',
  SetScrollTop = 'Set scroll top calendar',
  SetScrollDragging = 'Set scroll dragging',
  startScrolling = 'Start calendar scrolling',
  finishScrolling = 'End calendar scrolling',

  LoadCalendar = 'Fetch all data required to display valid calendar',
  IsLoading = 'Calendar is loading and wait for response',
  IsReady = 'Calendar is ready and can render its content',

  FetchUserCalendars = 'Fetch user calendars',
  CalendarsFetched = 'User calendars fetched from external API',

  FetchSelectedColumns = 'Fetch selected columns in booking calendar from external resource',
  SelectColumn = 'Select column in booking calendar without applying changes',
  ReplaceSelectedColumns = 'Select or unselect column and apply changes',

  ToggleSummary = 'Toggle calendar summary',
  RequestToggleSummary = 'Request toggle calendar summary',
  DeleteSelectedColumns = 'Delete selected column',
  AddSelectedColumns = 'Add selected column',

  MergeEventLabels = 'Add generated labels to store',
  SetSurveyModalShow = 'Set survey modal show',
  ToggleSurveyModal = 'toggle survey modal show'
}

export enum CalendarFiltersActions {
  ApplyFilters = 'Apply filters for rendered rooms',
  CleanFilters = 'Clean filters for rendered rooms',
  FilterByDate = 'Applied filters for rendered rooms by date attributes',
  FilterByPlace = 'Applied filters for rendered rooms by place attributes',
}

export enum RoomModalActions {
  ToggleCreateRoomModal = 'Toggle modal - create new room',
  ToggleUpdateRoomModal = 'Togggle modal - update an existing room',
  RequestUpdateRoomModal = 'Request for updating fields in modal',
  ToggleSaving = 'Toggle room saving',
}

export enum ReservationModalActions {
  ToggleCreateReservationModal = 'Toggle modal - create new reservation',
  ToggleCreateReservationModalRedux = 'Toggle modal - create new reservation redux',
  ToggleUpdateReservationModal = 'Toggle modal - update an existing reservation',
  ToggleUpdateReservationModalRedux = 'Toggle modal - update an existing reservation redux',
  ToggleCloseModal = 'Toggle modal - reservation close',
  AddServicesToForm = 'Add services to form',
  ChangeChildren = 'Change children count',
  ChangeAdultsCount = 'Change adults count',
  ChangeDate = 'Change dates for reservation',
  ClearDateErrors = 'Clear reservation dates error',
  CalculateEndPrice = 'Calculate end price for reservation',
  CopyAddressValues = 'Copy address info from main guest to additional guest',
  ToggleLoading = 'Toggle loading reservation modal',
  OnChange = 'On reservation form values changes',
  ToggleCalculate = 'Toggle calculate',
  ToggleFieldVisibility = 'Toggle form field visibility',
  SetFieldsVisibility = 'Set visible fields for form',
  SetTab = 'Set selected reservation from tab',
  Validate = 'run async form reservtion validate',
  RequestCreateReservation = 'request toggle modal create reservation',
  ToggleSaving = 'Toggle reservation saving',
  ToggleTransferModal = 'Toggle modal transfer',
  ToggleTransferModalLoading = 'Toggle modal transfer loading',
  ToggleDeleteModal = 'Toggle delete reservation modal',
  ToggleUpdateReservationModalWithLoad = 'Toggle update with load reservation modal',
  CloseModals = 'Close reservation form modals',
}

export enum ServicesModal {
  ToggleServicesModal = 'Toggle modal - services',
  ToggleServicesModalLoading = 'Toggle services modal loading',
  ServicesAccepted = 'Services was accepted from api',
}

export enum ConfigurationModalActions {
  ToggleCreateModal = 'Toggle modal - create modal',
  ChangeConfiguration = 'Change reservation form configuration',
}

export enum CopyModal {
  OpenCopyModal = 'Open modal - copy',
  CloseCopyModal = 'Close modal - copy',
  ToggleCopyModalLoading = 'Toggle copy modal loading',
}
